export const onHandleSingleFile = (event) => {
  const file = event?.target?.files?.[0];
  if (!file) return null;

  return file;
};

export const onHandleMultipleFiles = (event, mimeCategory = "image") => {
  const files = event?.target?.files;
  if (!files) return [];

  return Array.from(files).filter((file) =>
    file.type?.startsWith(`${mimeCategory}/`),
  );
};

export const formatFileSize = (bytes) => {
  const units = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Bytes";

  const index = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = (bytes / Math.pow(1024, index)).toFixed(2);

  return `${size} ${units[index]}`;
};

export const onHandleRenameFile = (_file, _newName) => {
  const ext = _file?.name.split(".").pop();
  const newName = `${_newName}.${ext}`;
  const newFile = new File([_file], newName, {
    type: _file?.type,
  });
  return newFile;
};

export const getMimeType = (filename = "") => {
  const ext = filename.split(".").pop()?.toLowerCase();

  const map = {
    mp3: "audio/mpeg",
    wav: "audio/wav",
    ogg: "audio/ogg",
    mp4: "video/mp4",
    webm: "video/webm",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
  };

  return map[ext] || "application/octet-stream";
};
